import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";

export const siteId67: SiteIdOverrideConfig = {
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    driveAgeCheckbox: true,
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
